/** The Data frame (code name `dataset`): its card, opened table and delete confirmation. */
export default {
  rowCount: { one: "{count} row", other: "{count} rows" },
  noRows: "No rows yet",
  tableLabel: "{title} table",
  range: "{from} to {to} of {total}",
  previousRows: "Previous rows",
  nextRows: "Next rows",
  undo: "Undo last change",
  addRow: "Add row",
  deleteRow: "Delete row",
  rowMenu: "Row actions",
  undoDelete: "Undo",
  editCell: "Edit {field}",
  addValue: "Add {field}",
  loadingRows: "Loading rows",
  loadFailed: "Couldn't load rows",
  retry: "Try again",
  conflict: "Changed by Denker just now. Showing the latest value.",
  mustBeNumber: "Must be a number",
  saved: "Saved",
  saveFailed: "Couldn't save this change",
  rowAdded: "Row added",
  rowDeleted: "Row deleted",
  undone: "Last change undone",
  nothingToUndo: "Nothing to undo",
  undoRefused: "Can't undo: these rows changed since.",
  tableFull:
    "This table is full (50,000 rows). Delete rows or start a new table.",
  deleteTitle: {
    one: "Delete {title} and its {count} row?",
    other: "Delete {title} and its {count} rows?",
  },
  deleteConsumers: {
    one: "{names} will stop updating.",
    other: "{names} will stop updating.",
  },
  addField: "Add field",
  columns: "Columns",
  fieldMenu: "{field} field menu",
  renameField: "Rename",
  renameFieldTitle: "Rename field",
  deleteField: "Delete field",
  options: "Options",
  removeOption: "Remove {label}",
  removeOptionConfirm: "Remove option",
  fieldName: "Name",
  fieldType: "Type",
  fieldOptions: "Options",
  fieldOptionsHint: "High, Medium, Low",
  type_text: "Text",
  type_number: "Number",
  type_decimal: "Decimal",
  type_boolean: "Yes or no",
  type_date: "Date",
  type_datetime: "Date and time",
  type_select: "Choice",
  deleteFieldTitle: "Delete the field {field}?",
  removeOptionTitle: "Remove the option {label} from {field}?",
  rowsLose: {
    one: "{count} row loses its value.",
    other: "{count} rows lose their value.",
  },
  fieldCharts: "Read by {names}. A chart that shows this field stops updating.",
  optionCharts: "Read by {names}.",
  fieldChangeFailed: "Couldn't change the fields",
  fieldsChanged: "The fields changed. Showing the latest.",
} as const;
